module.exports = __webpack_public_path__ + "img/age-confirm-main-img.3e3bd604.svg";